import axios from "axios";
import { apiClient } from "../config/axios";
import { tokenManager } from "./tokenManager";
import type { AuthResponse, LoginPayload, RegisterPayload, User } from "../types/auth.types";

const API_BASE_URL = process.env.REACT_APP_URL_API;

export const authService = {
    async login(payload: LoginPayload): Promise<AuthResponse> {
        const { data } = await apiClient.post<AuthResponse>("/v1/auth/login", payload);
        return data;
    },

    async register(payload: RegisterPayload): Promise<AuthResponse> {
        const { data } = await apiClient.post<AuthResponse>("/v1/auth/register", payload);
        return data;
    },

    async logout(): Promise<void> {
        await apiClient.post("/v1/auth/logout");
    },

    async getProfile(): Promise<User> {
        const { data } = await apiClient.get<User>("/v1/auth/profile");
        return data;
    },

    async setPassword(currentPassword: string, newPassword: string): Promise<void> {
        await apiClient.patch("/v1/auth/set-password", { currentPassword, newPassword });
    },

    async refresh(): Promise<AuthResponse> {
        const refreshTkn = tokenManager.getRefreshToken();
        const { data } = await axios.post<AuthResponse>(
            `${API_BASE_URL}/v1/auth/refresh`,
            {},
            {
                headers: {
                    "x-refresh-token": refreshTkn || "",
                },
                withCredentials: true,
            }
        );
        return data;
    },
};
